import styled from 'styled-components';
import { Box } from '@mantine/core';

export const NewTableCellWrapper = styled(Box)`
  &:hover {
    .cell-comment-container {
      visibility: visible;
      right: ${({ $commentRightOffset }) => $commentRightOffset ?? 8}px;
    }
  }
`;
